import moment from 'moment';

export const validateIntervals = (newIntervals) => {
  const allIntervals = [];

  newIntervals.forEach(({ beginningEnd }) => {
    if (beginningEnd?.length === 2) {
      allIntervals.push({
        start: moment(beginningEnd[0], 'HH:mm'),
        end: moment(beginningEnd[1], 'HH:mm'),
      });
    }
  });

  for (let i = 0; i < allIntervals.length - 1; i++) {
    const current = allIntervals[i];
    const next = allIntervals[i + 1];

    if (next.start.isBefore(current.end)) {
      return false;
    }

    if (current.end.isAfter(next.start)) {
      return false;
    }
  }

  for (let i = 0; i < allIntervals.length; i++) {
    for (let j = i + 1; j < allIntervals.length; j++) {
      const a = allIntervals[i];
      const b = allIntervals[j];

      if (
        (a.start.isBefore(b.end) || a.start.isSame(b.end)) &&
        (b.start.isBefore(a.end) || b.start.isSame(a.end))
      ) {
        return false;
      }
    }
  }

  return true;
};
